module.exports = __webpack_public_path__ + "ca794ec454e51e30da0e37c6cf38a856.png";